import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  CSidebar,
  CSidebarNav,
  CNavItem,
  CNavLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import { CIcon } from "@coreui/icons-react";
import { cilCreditCard, cilSpeech, cilCalendar, cilStar } from "@coreui/icons";

import {
  cilHome,
  cilUser,
  cilSettings,
  cilAccountLogout,
  cilBell,
  cilLifeRing,
  cilQuestion,
  cilDescription,
  cilLockLocked,
  cilChatBubble,
  cilPencil,
} from "@coreui/icons";
// import "../Sidebar/Sidebar.css";
import "../CounsellorSidebar/CounsellorSidebar.css";
import Swal from "sweetalert2";
import { getUserById } from "../api/api";
import { environment } from "../../environments/environments";
import aboutbanners from "../../assets/images/about-head-banner.jpg";

const CounsellorSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [userData, setUserdata] = useState(null);
  useEffect(() => {
    const getUser = async () => {
      const storedUser = JSON.parse(localStorage.getItem("currentUser"));
      const _id = storedUser?.id || storedUser?._id;
      const res = await getUserById({ user_id: _id });
      console.log("getUserbyId_call_in_Counsellor_Sidebar", res);
      setUserdata(res);
    };
    getUser();
  }, []);

  const handleDropdownClick = (option) => {
    if (option === "sendSupport") {
      navigate("/Sidebar/send-support");
    } else if (option === "raisePayment") {
      navigate("/Sidebar/raise-payment");
    }
  };

  useEffect(() => {
    if (location.pathname === "/CounsellorSidebar") {
      navigate("/CounsellorSidebar/CounsellorBooking");
    }
  }, [location, navigate]);

  const isActiveRoute = (route) => location.pathname === route;
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e04a48",
      cancelButtonColor: "#058787",
      confirmButtonText: "Yes, Logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("currentUser");
        // navigate("/CounsellorRegistration");
        window.dispatchEvent(new Event("userLoggedOut"));
        navigate("/Login");
      }
    });
  };
  return (
    <div className="">
      <div
        className="dadhbrdbnnr"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
      </div>
      <div className="mainallpages">
        <CSidebar
          style={{
            backgroundColor: "#fedcdb",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "80px",
              backgroundColor: "#e04a48",
            }}
          >
            <img
              src={`${environment.url}uploads/counsellors/${userData?.data?.image}`}
              alt="Logo"
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                marginLeft: "10px",
              }}
            />
            <div className="nameEmaildiv">
              <h3
                style={{
                  color: "#fff",
                  fontSize: "20px",
                  marginBottom: "0px",
                  marginLeft: "10px",
                }}
              >
                {userData?.data?.name}
              </h3>
              <h3
                style={{
                  color: "#fff",
                  fontSize: "13px",
                  marginBottom: "0px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {userData?.data?.email}
              </h3>
            </div>
          </div>
          <CSidebarNav>
            <CNavItem>
              <CNavLink
                as={Link}
                to="/CounsellorSidebar/CounsellorBooking"
                className={`nav-link ${isActiveRoute("/CounsellorSidebar/CounsellorBooking")
                  ? "active-link"
                  : ""
                  }`}
              >
                <CIcon icon={cilCalendar} className="custom-icon-size" />
                <span className="link-text">All Bookings</span>
              </CNavLink>
            </CNavItem>

            <CNavItem>
              <CNavLink
                as={Link}
                to="/CounsellorSidebar/Rating"
                className={`nav-link ${isActiveRoute("/CounsellorSidebar/Rating")
                  ? "active-link"
                  : ""
                  }`}
              >
                <CIcon icon={cilStar} className="custom-icon-size" />
                <span className="link-text">Users Rating</span>
              </CNavLink>
            </CNavItem>

            <CNavItem>
              <CNavLink
                as={Link}
                to="/CounsellorSidebar/CounsellorEditProfile"
                className={`nav-link ${isActiveRoute("/CounsellorSidebar/CounsellorEditProfile")
                  ? "active-link"
                  : ""
                  }`}
              >
                <CIcon icon={cilPencil} className="custom-icon-size" />
                <span className="link-text">Edit Profile</span>
              </CNavLink>
            </CNavItem>

            <CNavItem>
              <CNavLink
                as={Link}
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
                className="nav-link"
              >
                <CIcon icon={cilAccountLogout} className="custom-icon-size" />
                <span className="link-text">Logout</span>
              </CNavLink>
            </CNavItem>
          </CSidebarNav>
        </CSidebar>
        <div className="mainpagesss">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CounsellorSidebar;
